import React from 'react'
import { connect } from 'react-redux'
import Loading from './widgets/Loading'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'

import {
    DIRECTORY_UPDATE_PAGE_LOADED,
    DIRECTORY_UPDATE_PAGE_UNLOADED,
    DIRECTORY_UPDATE,
    DIRECTORY_REMOVE
} from '../constants/actionTypes'
import Nav from './widgets/Nav'
import Header from './widgets/Header'

import { Link } from 'react-router-dom'
import Util from '../util/util'
import LogList from './widgets/LogList'
import ListErrors from './widgets/ListErrors'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'
const Promise = global.Promise

const mapStateToProps = state => ({
    ...state.file,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
})

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: DIRECTORY_UPDATE_PAGE_LOADED, payload }),
    onSubmit: (payload, directory) => {
        dispatch({ type: DIRECTORY_UPDATE, payload, directory })
    },
    onDelete: (payload, directory) => {
        dispatch({ type: DIRECTORY_REMOVE, payload, directory })
    },
    onUnload: () =>
        dispatch({ type: DIRECTORY_UPDATE_PAGE_UNLOADED }),
})

class DirectoryEdit extends React.Component {
    constructor() {
        super()
        this.state = {
            name: '',
            parent: '',
        }
        this.updateState = field => ev => {
            const state = this.state
            const newState = Object.assign({}, state, { [field]: ev.target.value })
            this.setState(newState)
        }
        this.submitForm = () => ev => {
            ev.preventDefault()
            const name = this.state.name
            const key = this.props.match.params.key
            const payload = agent.Files.updateDirectory(this.props.match.params.key, name)
            this.props.onSubmit(payload, key)
        }
        this.deleteDirectory = () => ev => {
            ev.preventDefault()
            const key = this.props.match.params.key
            const parent = this.state.parent
            const payload = agent.Files.removeDirectory(key)
            this.props.onDelete(payload, parent)
        }
    }

    componentWillMount() {
        if (this.props.currentUser) {
            const key = this.props.match.params.key
            const payload = Promise.all([
                agent.Files.getDirectorySimple(key),
                agent.Files.getDirectoryLogs(key, 1)
            ])
            this.props.onLoad(payload)
        } else {
            store.dispatch(push("/login"))
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.directory && nextProps.directory !== this.props.directory) {
            Object.assign(this.state, {
                key: nextProps.directory.key,
                parent: nextProps.directory.parent,
                name: nextProps.directory.name
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        if (!this.props.directory) {
            return (
                <Loading currentUser={this.props.currentUser} />
            )
        }
        const name = this.state.name
        const directory = this.props.directory
        const directory_path = Util.generateDirectoryPath(directory)
        return (
            <Translation>
                {
                    (t) => (
                        <div id="main">
                            <Nav selected={'files'} currentUser={this.props.currentUser} />
                            <div id="content">
                                <Header />
                                <div id="content-clear">
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>
                                                <Link to={`/files?directory=${directory.key}`}><i className="fad fa-chevron-square-left"></i></Link> {t('file.edit_directory_title')}
                                            </h2>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_current_directory')}</label>
                                            <span><i className="fad fa-folder"></i> {directory_path}</span>
                                        </div>
                                        <div className="form-item">
                                            <label>{t('file.label_name')}</label>
                                            <input type="text" placeholder="" value={name} onChange={this.updateState('name')} />
                                        </div>

                                        <ListErrors errors={this.props.errors} />

                                        <div className="form-item">
                                            <button type="button" onClick={this.submitForm()} disabled={this.props.inProgress}>{this.props.inProgress ? t('file.update_button_progress') : t('file.update_button')} </button>
                                            <button type="button" className='button-lite' onClick={this.deleteDirectory()} disabled={this.props.inProgress}>{t('file.delete_directory_button')}</button>
                                        </div>
                                    </div>
                                    <div className="focus-wrap">
                                        <div className='box-header'>
                                            <h2>{t('file.update_logs_title')}</h2>
                                        </div>
                                        <LogList data={this.props.logs} loading={this.props.loading} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Translation>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DirectoryEdit)
